import { InjectionToken } from '@angular/core';
import { ApplicationTypeToken } from './environment.constant';

export const env = new InjectionToken<unknown>('env');
export const APPLICATION_TYPE_TOKEN = new InjectionToken<ApplicationTypeToken>('APPLICATION_TYPE_TOKEN');
